import React from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import { LocalStorage } from '../../utils/localStorage';

type SaveButtonProps = {
  disabled?: boolean
}
function SaveButton({disabled} : SaveButtonProps) {
  const roles = LocalStorage.userRole.get();
  return (roles?.includes('diagperm-admin') ||
    roles?.includes('diagperm-edit')) === true ? (
    <Container className='saveButton'>
      <Container className='styledSectionButton'>
        <Button
          type='submit'
          className='save-btn'
          mode='plain'
          data-testid='submit-btn'
          disabled={disabled}
        >
          <Word
            className='note-style'
            variant='span'
            textStyle='normalBold'
            value='Enregistrer les modifications'
          />
        </Button>
      </Container>
    </Container>
  ) : null;
}

export default SaveButton;
